import { LEGEND } from "@/shared/components/gantt-carga/gantt-carga.constants";
import { Button } from "primereact/button";

import { Illustration, Loading } from "@/ds";
import { GanttProfissionais as Gantt } from "../../gantt-profissionais";
import { BotaoIndicadores } from "../../botao-indicadores";
import { IndicadoresDialog } from "../../indicadores-dialog";
import { LegendSwatch } from "../../legend-swatch";
import type { LegendSwatchKind } from "../../legend-swatch";
import {
  CALENDARIO_HEADER_LABEL,
  CALENDARIO_HOJE_LABEL,
  CALENDARIO_LEGENDA_LABEL,
  CALENDARIO_LOADING_MESSAGE,
  CALENDARIO_RETRY_LABEL,
  EQUIPE_CALENDARIO_EMPTY,
  EQUIPE_CALENDARIO_SUBTITLE,
  EQUIPE_TAB_CALENDARIO,
  NOVA_OBRA_LABEL,
} from "../equipe-obra.constants";
import styles from "./calendario-alocacao-tab.module.scss";
import type {
  CalendarioAlocacaoTabProps,
  CalendarioAlocacaoTabViewModel,
} from "./types-calendario-alocacao-tab";

/**
 * Aba "Calendário de Alocação" (HU 2059): Gantt dos profissionais da equipe com a Nova Obra e as alocações e
 * indisponibilidades que eles já têm; os conflitos são só informativos, a decisão fica para o Salvar.
 */
export function CalendarioAlocacaoTabView({
  today,
  semMembros,
  carregando,
  falhou,
  podeTentarDeNovo,
  mensagemErro,
  tentarDeNovo,
  gantt,
  indicators,
  indicatorOptions,
  indicatorsOpen,
  abrirIndicadores,
  fecharIndicadores,
  aplicarIndicadores,
}: CalendarioAlocacaoTabProps & CalendarioAlocacaoTabViewModel) {
  return (
    <div className={styles.calendario} data-testid="equipe-obra-calendario">
      <div className={styles.cabecalho}>
        <h3 className={styles.titulo}>{EQUIPE_TAB_CALENDARIO}</h3>
        <p className={styles.subtitulo}>{EQUIPE_CALENDARIO_SUBTITLE}</p>
      </div>

      {semMembros ? (
        <div className={styles.vazio}>
          <p className={styles.vazioTexto}>{EQUIPE_CALENDARIO_EMPTY}</p>
          <Illustration name="sem-dados" decorative testId="equipe-obra-calendario-ilustracao" />
        </div>
      ) : null}

      {carregando ? (
        <div className={styles.state} role="status" data-testid="equipe-obra-calendario-loading">
          <Loading aria-hidden />
          {CALENDARIO_LOADING_MESSAGE}
        </div>
      ) : null}

      {falhou ? (
        <div className={styles.state} role="alert" data-testid="equipe-obra-calendario-error">
          <span>{mensagemErro}</span>
          {podeTentarDeNovo ? (
            <Button
              type="button"
              label={CALENDARIO_RETRY_LABEL}
              icon="pi pi-refresh"
              size="small"
              outlined
              onClick={tentarDeNovo}
              data-testid="equipe-obra-calendario-retry"
            />
          ) : null}
        </div>
      ) : null}

      {gantt ? (
        <>
          <div className={styles.toolbar}>
            <ul className={styles.legend} aria-label="Legenda" data-testid="equipe-obra-legenda">
              <li className={styles.legendTitle}>{CALENDARIO_LEGENDA_LABEL}</li>
              <li className={styles.legendItem}>
                <LegendSwatch kind="transferida" />
                {NOVA_OBRA_LABEL}
              </li>
              {LEGEND.map((item) => (
                <li key={item.key} className={styles.legendItem}>
                  <LegendSwatch kind={item.key as LegendSwatchKind} />
                  {item.label}
                </li>
              ))}
              <li className={styles.legendItem}>
                <LegendSwatch kind="hoje" />
                {CALENDARIO_HOJE_LABEL}
              </li>
            </ul>
          </div>
          <BotaoIndicadores
            onClick={abrirIndicadores}
            testId="equipe-obra-calendario-indicadores"
          />
          <div className={styles.gantt}>
            <Gantt
              rows={gantt.rows}
              timeline={gantt.timeline}
              today={today}
              headerLabel={CALENDARIO_HEADER_LABEL}
              semAcoes
            />
          </div>
        </>
      ) : null}

      {indicatorsOpen ? (
        <IndicadoresDialog
          opcoes={indicatorOptions}
          value={indicators}
          onSave={aplicarIndicadores}
          onCancel={fecharIndicadores}
        />
      ) : null}
    </div>
  );
}
